module.exports = __webpack_public_path__ + "img/duhanhgia.78485297.png";